import PropTypes from 'prop-types';
import React from 'react';
import IconButton from '@99designs/react-components/components/IconButton';
import Icon from '@99designs/react-components/components/Icon';
import bemComponent from '@99designs/utils/app/bemComponent';

class SidebarHeader extends React.Component {
    render() {
        return (
            <div className="sidebar-header">
                {this.props.isCloseButtonEnabled && (
                    <div className="sidebar-header__close-button">
                        <IconButton
                            onClick={this.props.closeOverlayHandler}
                            variations={['on-white']}
                        >
                            <Icon variations={['x-3']} />
                        </IconButton>
                    </div>
                )}
                {this.props.children}
            </div>
        );
    }
}

SidebarHeader.propTypes = {
    closeOverlayHandler: PropTypes.func,
    isCloseButtonEnabled: PropTypes.bool,
};

SidebarHeader.defaultProps = {
    closeOverlayHandler: null,
    isCloseButtonEnabled: true,
};

export default {
    Main: SidebarHeader,
    Heading: bemComponent('sidebar-header__heading'),
    HeadingText: bemComponent('sidebar-header__heading__text'),
    HeadingPill: bemComponent('sidebar-header__heading__pill'),
    SubHeading: bemComponent('sidebar-header__sub-heading'),
    Section: bemComponent('sidebar-header__section'),
    Description: bemComponent('sidebar-header__description'),
    DescriptionItem: bemComponent('sidebar-header__description__item'),
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/SidebarHeader.jsx